import mongoose from 'mongoose';
import icoTransactionSchema, { IIcoTransactionDocument } from '../schemas/ico-transaction';

export default (mongoose.models.IcoTransaction ||
  mongoose.model<IIcoTransactionDocument>(
    'IcoTransaction',
    icoTransactionSchema,
  )) as mongoose.Model<IIcoTransactionDocument>;
